/** ~15m at mid-latitudes; stops closer than this are treated as overlapping */
const NEARBY_THRESHOLD_DEG = 0.00014;

const DISPLAY_SLOTS = [
  { offsetX: 0, offsetY: 0, labelSlot: 'slot-0' },
  { offsetX: 16, offsetY: -6, labelSlot: 'slot-1' },
  { offsetX: -16, offsetY: -6, labelSlot: 'slot-2' },
  { offsetX: 20, offsetY: 4, labelSlot: 'slot-3' },
  { offsetX: -20, offsetY: 4, labelSlot: 'slot-4' },
  { offsetX: 16, offsetY: 14, labelSlot: 'slot-5' },
  { offsetX: -16, offsetY: 14, labelSlot: 'slot-6' },
  { offsetX: 0, offsetY: 18, labelSlot: 'slot-7' },
];

export const areCoordsNear = (a, b, thresholdDeg = NEARBY_THRESHOLD_DEG) =>
  Math.abs(a.lon - b.lon) <= thresholdDeg && Math.abs(a.lat - b.lat) <= thresholdDeg;

const clusterStops = stops => {
  const clusters = [];

  stops.forEach(stop => {
    const cluster = clusters.find(group => group.some(item => areCoordsNear(item, stop)));
    if (cluster) {
      cluster.push(stop);
    } else {
      clusters.push([stop]);
    }
  });

  return clusters;
};

/** Flat list of pickup/dropoff markers with pixel offsets so overlaps remain readable */
export const buildRouteStopMarkers = mapRouteDirections => {
  if (!mapRouteDirections?.length) {
    return [];
  }

  const stops = [];
  mapRouteDirections.forEach(detail => {
    stops.push({
      id: `${detail.id}-pickup`,
      jobId: detail.id,
      stopType: 'pickup',
      lon: detail.start_lon,
      lat: detail.start_lat,
      time: detail.start_time,
    });
    stops.push({
      id: `${detail.id}-dropoff`,
      jobId: detail.id,
      stopType: 'dropoff',
      lon: detail.end_lon,
      lat: detail.end_lat,
      time: detail.end_time,
    });
  });

  clusterStops(stops).forEach(cluster => {
    cluster.forEach((stop, index) => {
      const slot = DISPLAY_SLOTS[index % DISPLAY_SLOTS.length];
      stop.offsetX = slot.offsetX;
      stop.offsetY = slot.offsetY;
      stop.labelSlot = slot.labelSlot;
      stop.stackOrder = index;
    });
  });

  return stops;
};
